export enum FormErrorType {
    HelperText = -1,
    Warning = 1,
    Low = 2,
    Normal = 3,
    High = 4,
    Critical = 5
}

export default FormErrorType;